export default __webpack_public_path__ + "static/media/Snd_A_Starts.081e75f6.mp3";